import { Select } from "antd";
import useWarehouse from "../customHooks/useWarehouse";
import { useEffect } from "react";

const WarehouseSelect = ({ value, onChange, ...rest }) => {
  const { data, isLoading } = useWarehouse();

  useEffect(() => {
    if (!isLoading && data?.length === 1) {
      onChange?.(data[0].id);
    }
  }, [data, isLoading, onChange]);

  return (
    <Select
      disabled={isLoading}
      value={value}
      onChange={onChange}
      {...rest}
      options={data?.map((c) => ({
        value: c.id,
        label: c.name,
      }))}
    />
  );
};

export default WarehouseSelect;